import React from 'react'
import PropTypes from 'prop-types'
import { isFunction } from 'lodash-es'
import * as warning_ from 'warning'

import { Button, IButtonProps } from '../button'

const warning = warning_

function isPromise(value: unknown): value is Promise<any> {
  return value && isFunction((value as Promise<any>).then)
}

interface IUncontrolledProcessingButtonState {
  processing: boolean
}

export class UncontrolledProcessingButton extends React.Component<
  Pick<IButtonProps, Exclude<keyof IButtonProps, 'processing'>>,
  IUncontrolledProcessingButtonState
> {
  static propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func.isRequired,
  }

  mounted = false
  state: IUncontrolledProcessingButtonState = {
    processing: false,
  }

  componentDidMount() {
    this.mounted = true
  }

  componentWillUnmount() {
    this.mounted = false
  }

  onClick = () => {
    const maybePromise = this.props.onClick && this.props.onClick()

    if (isPromise(maybePromise)) {
      this.setState({ processing: true })
      return maybePromise.then(this.resetState).catch(this.resetState)
    }

    warning(isPromise(maybePromise), "UncontrolledProcessingButton's onClick callback must return a Promise")
  }

  resetState = () => this.mounted && this.setState({ processing: false })

  render() {
    return (
      <Button {...this.props} onClick={this.onClick} processing={this.state.processing}>
        {this.props.children}
      </Button>
    )
  }
}
